
import React from 'react';

export default () => {
    return (
        <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 0C2.75925 0 1.75 1.07131 1.75 2.38775V5.83673C1.75 7.15318 2.75925 8.22449 4 8.22449C5.24075 8.22449 6.25 7.15318 6.25 5.83673V2.38775C6.25 1.07131 5.24075 0 4 0ZM0.5 5.96939C0.224 5.96939 0 6.2071 0 6.5C0 8.4579 1.53016 10.0759 3.5 10.3138V11.9388H1.75C1.474 11.9388 1.25 12.1765 1.25 12.4694C1.25 12.7623 1.474 13 1.75 13H6.25C6.526 13 6.75 12.7623 6.75 12.4694C6.75 12.1765 6.526 11.9388 6.25 11.9388H4.5V10.3138C6.46984 10.0759 8 8.4579 8 6.5C8 6.2071 7.776 5.96939 7.5 5.96939C7.224 5.96939 7 6.2071 7 6.5C7 8.03612 5.65425 9.28571 4 9.28571C2.34575 9.28571 1 8.03612 1 6.5C1 6.2071 0.776 5.96939 0.5 5.96939Z" fill="#00787A"/>
        </svg>
    );
};
